import React, { useEffect, useRef } from "react";
// import { useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import {
  filterBy,
  CompositeFilterDescriptor,
} from "@progress/kendo-data-query";
import {
  Grid as KendoGrid,
  GridColumn as Column,
  //   GridCellProps,
  GridFilterChangeEvent,
  GridPageChangeEvent,
  GridCustomHeaderCellProps,
  GridCustomCellProps,
  GridCellProps,
} from "@progress/kendo-react-grid";
import { GridLayout, GridLayoutItem } from "@progress/kendo-react-layout";
import { PagerTargetEvent } from "@progress/kendo-react-data-tools";
import { HeaderThElement } from "@progress/kendo-react-data-tools";
import { Typography } from "@progress/kendo-react-common";
// import { Button } from "@progress/kendo-react-buttons";
// import { FiEdit } from "react-icons/fi";
// import { Switch } from "@progress/kendo-react-inputs";
import AlertBox from "../../components/common/AlertBox";
import { LoadingPanel } from "../../components/layout/Loading";
import IconButton from "../../components/common/IconButton";
// import AppDialog, { DialogCloseButton } from "../../components/dialog/Dialog";
import { closeDialog, openDialog } from "../../components/dialog/dialogSlice";
// import { MdDelete } from "react-icons/md";

// import { checkAcessRights } from "../../_helper/helper";
import //   DELETE_ACCESS,
//   EDIT_ACCESS,
//   INSERT_ACCESS,
"../../_contstants/common";
import {
  getAllQuotation,
  getQuotationByID,
} from "./services/quotation.services";
import { FaEye } from "react-icons/fa6";
import { clearQuotationDetail } from "./quotationSlice";
import AppDialog from "../../components/dialog/Dialog";
import { Button } from "@progress/kendo-react-buttons";
import moment from "moment";
import { checkAcessRights } from "../../_helper/helper";
import { EXCEL_EXPORT_ACCESS } from "../../_contstants/common";
import { saveAs } from "file-saver";
import * as XLSX from "xlsx";
const Quotation: React.FC = () => {
  const dispatch = useAppDispatch();
  //   const navigate = useNavigate();
  const isExcelAccess = checkAcessRights(
    location.pathname,
    EXCEL_EXPORT_ACCESS
  );
  //   const isAddAccess = checkAcessRights(location.pathname, INSERT_ACCESS);

  useEffect(() => {
    dispatch(getAllQuotation());
    return () => {
      dispatch(closeDialog());
    };
  }, []);

  const handleExportExcel = () => {
    const datetime = moment().format("DD-MM-YYYY HH-mm");
    const wb = XLSX.utils.book_new();
    const ws = XLSX.utils.table_to_sheet(
      document.querySelector(".table-bordered")
    );
    XLSX.utils.book_append_sheet(wb, ws, "Quotation");

    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const data = new Blob([excelBuffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    saveAs(data, `Quotation ${datetime}`);
  };

  //   const handleCreate = () => {
  //     navigate("/seotag/create");
  //   };

  return (
    <>
      {/* <DeleteQuotationDialog /> */}
      <QuotationDialog />
      <GridLayout cols={[{ width: "100%" }]}>
        <GridLayoutItem
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "4px 20px 20px 0",
            gap: "20px",
          }}
        >
          <Typography.h5 style={{ marginBottom: 0, marginLeft: "3px" }}>
            Quotation List
          </Typography.h5>
          {isExcelAccess && (
            <Button
              style={{ marginRight: 5 }}
              type="button"
              fillMode={"solid"}
              themeColor={"primary"}
              onClick={handleExportExcel}
            >
              Excel Export
            </Button>
          )}
          {/* {isAddAccess && (
            <Button
              onClick={handleCreate}
              fillMode={"solid"}
              themeColor={"primary"}
            >
              {"Create Seo Tag"}
            </Button>
          )} */}
        </GridLayoutItem>
        <GridLayoutItem>
          <QuotationGridComponent />
        </GridLayoutItem>
      </GridLayout>
    </>
  );
};

interface PageState {
  skip: number;
  take: number;
}

const initialDataState: PageState = { skip: 0, take: 10 };

const QuotationGridComponent: React.FC = () => {
  const gridRef = useRef<any>(null);
  const dispatch = useAppDispatch();
  //   const navigate = useNavigate();
  //   const isEditAccess = checkAcessRights(location.pathname, EDIT_ACCESS);
  //   const isDeleteAccess = checkAcessRights(location.pathname, DELETE_ACCESS);
  const QuotationList = useAppSelector(
    (state) => state.quotation.QuotationList
  );
  const loading = useAppSelector((state) => state.seotag.loading);
  // const [expandedRow, setExpandedRow] = useState(null);
  const [filter, setFilter] = React.useState<
    CompositeFilterDescriptor | undefined
  >(undefined);
  const [page, setPage] = React.useState<PageState>(initialDataState);
  const [pageSizeValue, setPageSizeValue] = React.useState<
    number | string | undefined
  >();

  const pageChange = (event: GridPageChangeEvent) => {
    const targetEvent = event.targetEvent as PagerTargetEvent;
    const take =
      targetEvent.value === "All" ? QuotationList.length : event.page.take;

    if (targetEvent.value) {
      setPageSizeValue(targetEvent.value);
    }
    setPage({
      ...event.page,
      take,
    });
  };

  const MyEditCommandCell = (props: GridCellProps) => {
    const handleItemView = async (ID: any) => {
      //   const payload = {
      //     ID: ID,
      //   };
      const res = await dispatch(getQuotationByID(ID));
      if (res.meta.requestStatus === "fulfilled") {
        dispatch(openDialog("quotationView"));
      }
    };

    return (
      <td
        className={`action-td ${props.className}`}
        style={{
          ...props.style,
        }}
      >
        <IconButton
          type="button"
          fillMode="flat"
          size="small"
          title="View"
          onClick={() => handleItemView(props.dataItem?.ID)}
        >
          <FaEye className="absolute-position" style={{ fontSize: "20px" }} />
        </IconButton>
      </td>
    );
  };

  const handleFilterChange = (e: GridFilterChangeEvent) => {
    setFilter(e.filter);
    setPage({ skip: 0, take: page.take });
  };
  const HeaderCustomCell = (props: GridCustomHeaderCellProps) => (
    <HeaderThElement
      columnId={props.thProps?.columnId || ""}
      {...props.thProps}
      className={`table-header ${props.index === 8 ? "locked-header" : ""}`}
    >
      {props.children}
    </HeaderThElement>
  );

  const CustomCell = (props: any) => {
    return (
      <td {...props.tdProps} colSpan={1} className={"table-cell"}>
        {props.children}
      </td>
    );
  };

  const MyDataCustomCell = (props: GridCustomCellProps) => (
    <CustomCell {...props} />
  );

  //   const MyActiveInActtiveCommandCell = (props: GridCellProps) => {
  //     const [IsActive, setIsActive] = useState<boolean>(props.dataItem.IsActive);

  //     const handleActiveInActive = () => {
  //       setIsActive(!IsActive);
  //       const data = {
  //         ID: props.dataItem.ID,
  //         IsActive: !IsActive,
  //       };
  //       dispatch(ActiveInactiveQuotation(data)).then((response: any) => {
  //         if (response.payload?.data?.Status === 200) {
  //           dispatch(getAllQuotation());
  //         } else {
  //           dispatch(getAllQuotation());
  //         }
  //       });
  //     };

  //     return (
  //       <td
  //         style={{ textAlign: "center", ...props.style }}
  //         className={props.className}
  //       >
  //         <Switch
  //           disabled={isEditAccess ? false : true}
  //           name="IsActive"
  //           checked={IsActive}
  //           onChange={handleActiveInActive}
  //           size="small"
  //         />
  //       </td>
  //     );
  //   };

  if (loading) return <LoadingPanel gridRef={gridRef} />;
  return (
    <>
      {QuotationList && QuotationList.length ? (
        <KendoGrid
          style={{ maxHeight: "calc(100vh - 152px)" }}
          filterable={true}
          className="table-bordered responsive-table"
          filter={filter}
          data={
            filter
              ? filterBy(QuotationList, filter).slice(
                  page.skip,
                  page.take + page.skip
                )
              : QuotationList.slice(page.skip, page.take + page.skip)
          }
          onFilterChange={handleFilterChange}
          skip={page.skip}
          take={page.take}
          total={QuotationList.length}
          pageable={{
            buttonCount: 5,
            pageSizes: [5, 10, 15, "All"],
            pageSizeValue: pageSizeValue,
            type: "input",
          }}
          onPageChange={pageChange}
          cells={{
            headerCell: HeaderCustomCell,
            data: MyDataCustomCell,
          }}
        >
          <Column
            field="QuotationDate"
            title="Quotation Date"
            cell={(props) => (
              <td>
                {" "}
                {props.dataItem.QuotationDate
                  ? moment(props.dataItem.QuotationDate, "DD/MM/YYYY").format(
                      "DD-MMM-YYYY"
                    )
                  : ""}
              </td>
            )}
            width={150}
          />
          <Column
            field="FirstName"
            title="Name"
            width={200}
            cell={(props) => (
              <td>{`${props.dataItem.FirstName} ${props.dataItem.LastName}`}</td>
            )}
          />

          <Column field="Email" title="Email" width={300} />
          <Column field="PhoneNo" title="Phone No  " width={150} />
          {/* <Column field="DateOfBirth" title="Date Of Birth" width={150} /> */}
          <Column
            field="DateOfBirth"
            title="Date of Birth"
            cell={(props) => (
              <td>
                {" "}
                {props.dataItem.DateOfBirth
                  ? moment(props.dataItem.DateOfBirth, "DD/MM/YYYY").format(
                      "DD-MMM-YYYY"
                    )
                  : ""}
              </td>
            )}
            width={150}
          />
          <Column field="Address" title="Address" width={300} />
          <Column
            field="IsNewComer"
            title="Is New comer"
            width={150}
            cell={(props) => (
              <td>{props.dataItem.IsNewComer ? "Yes" : "No"}</td>
            )}
          />

          <Column
            field="TotalTax"
            title="Total Tax"
            width={150}
            cell={(props) => (
              <td className="text-end">
                {props.dataItem.TotalTax ? `$ ${props.dataItem.TotalTax}` : ""}
              </td>
            )}
          />

          <Column
            field="ID"
            title="Actions"
            cell={MyEditCommandCell}
            width={"100px"}
            locked={true}
            filterable={false}
          />
        </KendoGrid>
      ) : (
        <AlertBox />
      )}
    </>
  );
};

const QuotationDialog: React.FC = () => {
  const dispatch = useAppDispatch();
  const gridRef = useRef<any>(null);
  const dialogName = useAppSelector((state) => state.dialog.dialogName);

  const QuotationDetailDetail = useAppSelector(
    (state) => state.quotation.QuotationDetail
  );
  const loading = useAppSelector((state) => state.quotation.loading);

  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === "Escape" || event.key === "Esc") {
        dispatch(clearQuotationDetail());
      }
    };
    window.addEventListener("keydown", handleKeyDown);

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, []);

  useEffect(() => {
    return () => {
      dispatch(clearQuotationDetail());
    };
  }, []);

  if (loading) return <LoadingPanel gridRef={gridRef} />;
  return (
    <>
      {dialogName === "quotationView" &&
        QuotationDetailDetail?.Services?.length > 0 && (
          <AppDialog className="inward-items-dialog">
            <>
              <Typography.h5>{"Quotation Services"}</Typography.h5>
              <GridLayout>
                <GridLayoutItem>
                  <div
                    className="table-responsive m-0"
                    style={{
                      maxHeight: "calc(100vh - 227px)",
                      scrollbarWidth: "thin",
                    }}
                  >
                    <table className="table table-bordered m-0">
                      <thead>
                        <tr>
                          <th style={{ background: "black", color: "white" }}>
                            No
                          </th>
                          <th style={{ background: "black", color: "white" }}>
                            Service Name
                          </th>

                          <th style={{ background: "black", color: "white" }}>
                            Description
                          </th>
                          {QuotationDetailDetail?.NoOfProperties != null &&
                            QuotationDetailDetail.NoOfProperties > 0 && (
                              <th
                                style={{ background: "black", color: "white" }}
                              >
                                No of Properties
                              </th>
                            )}
                          <th style={{ background: "black", color: "white" }}>
                            Charges
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {QuotationDetailDetail?.Services?.map(
                          (item: any, index: number) => {
                            // const totalNoOfProperties =
                            //   QuotationDetailDetail?.NoOfProperties ?? 1;
                            const totalNoOfProperties =
                              QuotationDetailDetail?.NoOfProperties ?? 1; // Default to 1 if null/undefined
                            const calculatedCharges =
                              item?.ServiceID === 4
                                ? item?.Charges * totalNoOfProperties
                                : item?.Charges;

                            return (
                              <tr key={index}>
                                <td>{index + 1}</td>
                                <td>{item?.ServiceName}</td>
                                <td width={"360px"}>{item?.Description}</td>
                                {QuotationDetailDetail?.NoOfProperties ? (
                                  <td className="text-center">
                                    {item?.ServiceID === 4
                                      ? totalNoOfProperties
                                      : ""}
                                  </td>
                                ) : null}

                                <td className="text-end">
                                  $ {calculatedCharges || 0}
                                </td>
                              </tr>
                            );
                          }
                        )}

                        <tr>
                          <td
                            colSpan={
                              (QuotationDetailDetail?.NoOfProperties ?? 0) > 0
                                ? 4
                                : 3
                            }
                            style={{
                              fontWeight: "900",
                              textAlign: "end",
                              backgroundColor: "whitesmoke",
                            }}
                          >
                            Total
                          </td>
                          <td
                            style={{
                              backgroundColor: "whitesmoke",
                              fontWeight: "900",
                              textAlign: "end",
                            }}
                          >
                            $ {QuotationDetailDetail?.TotalTax ?? 0}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </GridLayoutItem>
                <GridLayoutItem
                  style={{
                    display: "flex",
                    justifyContent: "end",
                    marginTop: 20,
                  }}
                >
                  <Button
                    onClick={() => {
                      dispatch(closeDialog());
                      dispatch(clearQuotationDetail());
                    }}
                    themeColor="error"
                    fillMode={"outline"}
                  >
                    Close
                  </Button>
                </GridLayoutItem>
              </GridLayout>
            </>
          </AppDialog>
        )}
    </>
  );
};

export default Quotation;
